import SpriteSymbol from "../../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "svgIcon-dots",
  "use": "svgIcon-dots-usage",
  "viewBox": "0 0 612 612",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 612 612\" id=\"svgIcon-dots\"><circle cx=\"69.545\" cy=\"306\" r=\"69.545\" fill=\"currentColor\" /><circle cx=\"306\" cy=\"306\" r=\"69.545\" fill=\"currentColor\" /><circle cx=\"542.455\" cy=\"306\" r=\"69.545\" fill=\"currentColor\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol